import { StyledTabs } from './style';

export function Tabs({ tabs = [], value, onChange }) {
  return (
    <StyledTabs>
      {tabs.map(item => (
        <button
          onClick={() => onChange(item)}
          className={`tab ${value?.id === item.id ? 'active' : ''}`}
          key={item.id}
        >
          {item.name}
          {(item.count === 0 || item.count > 0) && <div className="count">{item.count}</div>}
        </button>
      ))}
    </StyledTabs>
  );
}
